<template>
  <div class="pictureDrag">
    <el-form label-position="top" :rules="rules" ref="ruleForm" label-width="80px" :model="rulesForm">
      <vue-dividing-line title="基本設定"></vue-dividing-line>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="題目編號" prop="question_no">
            <el-input v-model="rulesForm.question_no" placeholder="請輸入題目編號"></el-input> </el-form-item
        ></el-col>
        <el-col :span="8">
          <el-form-item label="語言" prop="lang">
            <el-select v-model="rulesForm.lang" placeholder="請選擇語言">
              <el-option v-for="(item, index) in lang" :key="index"
                :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <!-- <el-col :span="8">
          <el-form-item label="語言" prop="lang">
            <el-select v-model="rulesForm.lang" placeholder="請選擇語言">
              <el-option v-for="(item, index) in lang" :key="index"
                :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col> -->
        <el-col :span="8">
          <el-form-item label="分數" prop="score"> 
            <el-input-number v-model="rulesForm.score" controls-position="right" :min="1" placeholder="請輸入分數"></el-input-number>
          </el-form-item
        ></el-col>
        <!-- <el-col :span="8">
          <el-form-item label="難易程度" prop="level">
            <el-select v-model="rulesForm.level" placeholder="請選擇難度">
              <el-option v-for="(item, idx) in level" :key="idx"
                :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item
        ></el-col> -->
      </el-row>
      <vue-dividing-line title="問題及插圖"></vue-dividing-line>
      <el-form-item label="問題" prop="title">
        <Tinymce v-model="rulesForm.title" ref="Tinymce"></Tinymce>
      </el-form-item>

      <vue-dividing-line title="背景圖片、拖拽選項及答案"></vue-dividing-line>
      <div class="required" style="margin-bottom: 10px;">問題圖片 *</div>
      <el-form-item label="" prop="img_url">
        <upload :placeholder="rulesForm.img_url || '請選擇問題圖片'" @childByValue="onUploadSuccess"></upload>
        <div class="img-box" v-if="rulesForm.img_url">
          <div class="close" @click="rulesForm.img_url = ''"></div>
          <img :src="rulesForm.img_url" />
        </div>
      </el-form-item>
      <div>
        <i class="el-icon-warning-outline"></i>
        在背景圖片上最多只可擺放10個拖拽框。
      </div>
      <div>
        <i class="el-icon-warning-outline"></i>
        每一個拖拽框只能配對一個選項。多餘選項則為幹擾選項。
      </div>
      <el-form-item label="">
        <div class="drag-area">
          <div class="design">
            <div class="question-design correct" :style="{backgroundImage: `url(${rulesForm.img_url})`}"></div>
            <div class="drag-btn" @click="drag.handleCreateBlock()">新增拖拽框</div>  
          </div>

          <div class="design">
            <div class="question-design mislead" :style="{backgroundImage: `url(${rulesForm.img_url})`}"></div>
            <div class="drag-btn" @click="misadviseDrag.handleCreateBlock(false)">新增誤導拖拽框</div>  
          </div>
        </div>
        
      </el-form-item>
      <!-- <el-row :gutter="20">
        <el-col :span="4" v-for="(item,index) in 10" :key="index">
          <div>選項 {{index+1}}</div>
          <upload></upload>
          <el-form-item label="問題">
            <el-input v-model="rulesForm.region" ></el-input>
          </el-form-item>
        </el-col>
      </el-row> -->
      <vue-dividing-line title="解答思路"></vue-dividing-line>
      <Tinymce v-model="rulesForm.explanation"></Tinymce>
      <div class="sibmit-button">
        <div class="left">
          <el-button type="info" @click="onSubmit">提交</el-button>
          <el-button type="success" @click="onBack">取消</el-button>
        </div>
        <el-button type="info" @click="preview">預覽題目</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import upload from "@/components/upload";
import Tinymce from "@/components/Tinymce";
import ImgDrag from '../plugins/imgDrag';
import { symbol } from '../plugins/directive'
import rules from "../plugins/validator";
export default {
  directives: {
    symbol
  },
  props: ['formLabelAlign'],
  components: { Tinymce, upload },
  data() {
    return {
      // 语言
      lang: [
        {label: '中文', value: 0},
        {label: '英文', value: 1},
      ],
      // 难易程度
      level: [
        {label: '※', value: 1},
        {label: '※※', value: 2},
        {label: '※※※', value: 3},
        {label: '※※※※', value: 4},
        {label: '※※※※※', value: 5},
      ],
      rulesForm: {},
      // rulesForm: {
      //   lang: "",
      //   title: "",
      //   img_url: '',
      //   type: 7,
      //   score: 1,
      //   level: 1,
      //   explanation: '',
      //   answers: [],
      //   choices: [],
      //   content: ''
      // },
      rules,
      units: [],

      drag: null,
      imageList: [],
      misadviseDrag: null,
      misadviseList: [],
    };
  },
  watch: {
    'rulesForm.img_url': function() {
      // 等问题图片加载出来后执行 防止背景模版对于文档的高度获取不准确
      setTimeout(() => {
        this.drag && this.drag.submitOffset()
        this.misadviseDrag && this.misadviseDrag.submitOffset()
      }, 500)
    }
  },  
  methods: {
    preview() {
      let form = this.handleFromData()
      form.type = 7
      this.$emit('preview', form)
    },
    childByVideoUrl(v) {
      this.rulesForm.videoUrl = v;
      this.$forceUpdate();
    },
    onUploadSuccess(url) {
      this.rulesForm.img_url = url;
    },
    handleFromData() {
      let form = JSON.parse(JSON.stringify(this.rulesForm)),
      { imageList, misadviseList } = this
      form.answers = []
      form.choices = []
      let newList = [...imageList, ...misadviseList]
      // console.log(imageList)
      // 处理數据 JSON.stringify([{"type": "image", value: item.image, ...item}
      newList.filter(item => {
        let value
        if(item.mislead) {
          value = [{
            type: 'image',
            x: item.x,
            y: item.y,
            width: item.width,
            height: item.height,
            value: item.image,
          }]
          form.answers.push({value: JSON.stringify(value)})
        } else form.answers.push({value: JSON.stringify([])})
        value = {
          x: item.x,
          y: item.y,
          width: item.width,
          height: item.height,
          opacity: item.opaqueBottom ? 100 : 0,
        }
        form.choices.push({value: JSON.stringify(value)})
      })
      form.content = JSON.stringify({
        imageList: newList
      })
      console.log(newList)
      return form
    },
    // 提交
    onSubmit() {
      let form = this.handleFromData()

      // console.log(form)
      // type, type_display
      this.$emit('save', form, 7, 7)
    },
    // 返回
    onBack() {
      this.$emit('cancel', this.rulesForm)
    },
  },
  created() {
    this.rulesForm = {...this.formLabelAlign}
  },
  mounted() {
    let t = null

    
    this.drag = new ImgDrag({
      plate: '.correct',
      blockStyle: {
        style: 'block-style',
        selectStyle: 'block-style-select'
      }
    })

    this.drag.callback((map) => {
      if(t != null) {
        clearTimeout(t)
        t = null
      }

      t = setTimeout(() => {
        // 处理數据
        let arr = [...map.values()]
        this.imageList = arr

        t = null
      }, 500)
    })

    this.misadviseDrag = new ImgDrag({
      plate: '.mislead',
      blockStyle: {
        style: 'block-style',
        selectStyle: 'block-style-select'
      }
    })

    this.misadviseDrag.callback((map) => {
      if(t != null) {
        clearTimeout(t)
        t = null
      }

      t = setTimeout(() => {
        // 处理數据
        let arr = [...map.values()]
        this.misadviseList = arr

        console.log(this.misadviseList)
        t = null
      }, 500)
    })
    
    if(this.rulesForm.id) {
      let {imageList} = JSON.parse(this.rulesForm.content)
      // this.imageList = imageList

      imageList.filter(its => {
        if(its.mislead) this.imageList.push(its)
        else this.misadviseList.push(its)
      })
      // console.log(imageList)
      this.drag.handleEchoBlock(this.imageList, this)
      this.misadviseDrag.handleEchoBlock(this.misadviseList, this)
    }

  }
};
</script>

<style scoped lang="scss">
.pictureDrag {
  .picture {
    width: 120px;
    height: 120px;
    border: 1px dashed #ccc;
    cursor: pointer;
    position: relative;

    img {
      position: absolute;
      width: 100%;
      height: 100%;
      z-index: 10;
    }

    &:after, &:before {
      position: absolute;
      content: '';
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 40%;
      height: 1px;
      margin: auto;
      background-color: #ccc;
    }

    &:before {
      height: 40%;
      width: 1px;
    }

    &:hover {
      border-color: #1a94fa;

      &:after, &:before {
        background-color: #1a94fa;
      }
    }
  }

  .design {
    margin: 20px 0 0 20px;
    .question-design {
      width: 500px;
      height: 302px;
      border: 1px dashed #ccc;
      box-sizing: initial;
      background-size: 100% auto;
      background-repeat: no-repeat;
      background-position: center center;
      box-sizing: border-box;
    }
    .drag-btn {
      margin: 20px 0 0 10px;
      width: 280px;
      height: 40px;
      background-color: #f6a053;
      border-radius: 50px;
      text-align: center;
      line-height: 40px;
      color: #333;
      font-size: 20px;
      cursor: pointer;
    }
  }

  .drag-area {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

}
</style>

<style lang="scss">
.right-key-menu {
  width: 150px;
  padding: 5px 0;
  box-sizing: border-box;
  background-color: #fff;
  box-shadow: 1px 1px 3px 1px #ccc;
  border-radius: 3px;
  position: absolute;
  top: 0;
  z-index: 9999;
  outline: none;

  .menu-single {
    width: 100%;
    padding: 5px;
    box-sizing: border-box;
    border-bottom: 1px solid #eee;
    font-size: 13px;
    text-align: center;
    cursor: pointer;

    &:hover {
      background-color: #eee;
    }
  }

  .menu-single:nth-last-of-type(1) {
    border: none;
  }
}

.pictureDrag .block-style {
  width: 80px;
  height: 80px;
  position: absolute;
  top: 80px;
  left: 80px;
  cursor: pointer;
  z-index: 1;
  background-color: #ccc;
  background-size: 100% 100%;
  
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 1px solid #000;
  }
}

.error-block-style {
  &:before {
    border-color: red !important;
  }

  & > * {
    border-color: red !important;
  }
}

.block-style-select {
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    // border: 1px solid #409EFF;
  }

  $dragSize: 8px;
  $shifting: -3px;
  .drag {
    position: absolute;
    width: $dragSize;
    height: $dragSize;
    border: 1px solid #409EFF;
    box-sizing: border-box;
    background-color: #fff;
    margin: auto;
  }

  .leftTop {
    top: $shifting;
    left: $shifting;
    cursor: nw-resize;
  }

  .top {
    top: $shifting;
    left: 0;
    right: 0;
    cursor: n-resize;
  }

  .rightTop {
    top: $shifting;
    right: $shifting - 2px;
    cursor: ne-resize;
  }

  .right {
    right: $shifting - 2px;
    top: 0;
    bottom: 0;
    cursor: e-resize;
  }

  .rightBottom {
    right: $shifting - 2px;
    bottom: $shifting - 2px;
    cursor: se-resize;
  }

  .bottom {
    left: 0;
    right: 0;
    bottom: $shifting - 2px;
    cursor: s-resize;
  }

  .leftBottom {
    left: $shifting;
    bottom: $shifting - 2px;
    cursor: sw-resize;
  }

  .left {
    top: 0;
    bottom: 0;
    left: $shifting;
    cursor: w-resize;
  }
}
</style>